module.exports = __webpack_public_path__ + "static/media/half_at_centre1.2bf4c3f1.jpg";